import { Paper, Theme } from '@mui/material';
import classNames from 'classnames';
import { ForwardedRef, ReactNode, forwardRef } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  className?: string;
  children: ReactNode;
  ref?: ForwardedRef<HTMLDivElement>;
}

const useStyles = createUseStyles((theme: Theme) => ({
  panel: {
    border: `1px solid ${theme.palette.divider}`,
    minWidth: 80,
  },
}));

const Panel = forwardRef<HTMLDivElement, Props>(({ children, className = '' }, ref) => {
  const styles = useStyles();
  const compClass = classNames(styles.panel, className);

  return (
    <Paper elevation={0} className={compClass} ref={ref}>
      {children}
    </Paper>
  );
});

Panel.displayName = 'Panel';

export default Panel;
